<template>
  <v-container fluid tag="section">
    <list-view :item='item' ref="list">
      <template v-slot:conditions='{ loading }'>
        <v-row>
          <v-col cols="12" md='2' class="pr-0">
            <v-text-field
              outlined dense
              hide-details
              clearable
              v-model='item.params.title'
              item-value="value"
              clear-icon="mdi-close-circle-outline"
              @keydown="queryKeyDown()"
              label="政策标题" >
            </v-text-field>
          </v-col>
          <v-col cols="12" md='2' class="pr-0">
            <v-select
              outlined dense
              :items="typeItems"
              label="文件归属"
              v-model="item.params.typeId"
              hide-details='auto'
              item-text='name'
              item-value="id"
              clearable
              clear-icon="mdi-close-circle-outline"
              @change="loadData"
            ></v-select>
          </v-col>
          <v-col cols="12" md='2'>
            <v-btn color="primary" :loading="loading" @click="loadData" class="mr-1 px-2" dark depressed>
              <v-icon>mdi-magnify</v-icon>查询
            </v-btn>
            <v-btn color="success" v-has="'pol-policy-info-add'" @click="addModal = { show: true}" class="mr-1 px-2" dark depressed>
              <v-icon>mdi-plus</v-icon>新增
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:actions='{ row }'>
        <v-spacer></v-spacer>
        <v-btn text @click='fileModal = { show: true, data: row}' class="pl-0" color="grey" small ><v-icon size="15" left>mdi-paperclip</v-icon>+附件</v-btn>
        <v-btn text @click='addModal = { show: true, data: row}' color="orange" small><v-icon size="15" left>mdi-pencil</v-icon>编辑</v-btn>
        <v-btn text @click='$refs.list.doDelete(row)' color="red" small><v-icon size="15" left>mdi-delete</v-icon>删除</v-btn>
      </template>
    </list-view>
    <add-view  :item='addModal'  @on-load-data='loadData'></add-view>
    <file-view :item='fileModal' @on-load-data='loadData'></file-view>
  </v-container>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import AddView from './components/Add.vue'
  import FileView from './components/File.vue'
  import ListView from '../components/List.vue'

  export default {
    name: 'PolicyIndex',
    components: {
      AddView,
      FileView,
      ListView
    },
    data() {
      return {
        addModal: { show: false },
        fileModal: { show: false },
        typeItems: [],
        item: {
          path: 'policy/info/list',
          topButtons: [
            { event: 'add', show: this.$_has('pol-policy-info-add') },
            { event: 'search', show: true }
          ],
          params: {
            title: ''
          }
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.list.loadData()
      },
      view (path) {
        if (path) {
          window.open(
            `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(path)}`,
            "_blank"
          );
        }
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.policyTypePid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
             if (this_.$constants.policyTypePid === result.id) {
                this_.typeItems = result.data
             }
           })
          }
        })
      }
    },
    created() {
      this.getTypes()
    }
  }
</script>

<style>
</style>
